import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Image from "src/components/elements/Image";
import MenuItemTextHighlighter from "src/components/navigation/MenuItemTextHighlighter";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";

const HeaderMenuItem = ({ data, image, group_id, searchTerm = "", handleClick = () => {}, mordernDesign = false }) => {
  const [imageError, setImageError] = useState(false);
  const { content_value } = useParams();

  const iconImage = () => {
    if (!image || imageError) return null;

    return (
      <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0")}>
        {isSVGString(image) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"'),
            }}
          />
        ) : (
          <Image
            src={image}
            alt="Menu image"
            onError={() => setImageError(true)}
          />
        )}
      </div>
    );
  };

  const isActive = () => {
    if (data.sub) {
      return (data._id === content_value || data.slug === content_value) && data.groupId === group_id;
    }

    return data._id === content_value || data.slug === content_value;
  };

  const buttonClasses = classNames(
    "flex min-h-10 w-full select-none items-center justify-start rounded px-3 transition-all",
    mordernDesign ? "hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor" : "hover:bg-headerMenuActiveBgColor hover:text-headerMenuActiveTextColor",
    isActive() ? (mordernDesign ? "bg-leftNavActiveColor text-leftNavActiveTextColor" : "bg-headerMenuActiveBgColor text-headerMenuActiveTextColor") : mordernDesign ? "text-leftNavTextColor" : "text-headerTextColor",
  );

  if (data.type === "internal") {
    return (
      <Link
        onClick={() => handleClick(data.groupId)}
        to={data.link}
        className={buttonClasses}>
        {iconImage()}
        <span
          className="truncate whitespace-nowrap font-medium"
          title={data.name}>
          <MenuItemTextHighlighter
            text={data.name}
            highlight={searchTerm}
          />
        </span>
      </Link>
    );
  }

  return (
    <a
      href={data.link}
      target={data.page_link_newtab ? "_blank" : "_self"}
      rel="noreferrer"
      className={buttonClasses}>
      {iconImage()}
      <span className="whitespace-nowrap font-medium">
        <MenuItemTextHighlighter
          text={data.name}
          highlight={searchTerm}
        />
      </span>
      <ArrowTopRightOnSquareIcon className="ml-2 h-4 w-4 stroke-2" />
    </a>
  );
};

export default HeaderMenuItem;
